import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import getPath from 'lodash/get';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import Dots from 'react-activity/lib/Dots';

import ImageCropModal from '../../../components/ImageCropModal';
import styles from './shared/styles';
import { ActionButton } from '../../../components/buttons/buttons';
import Loading from '../../../components/Loading';
const {
  podcastCategories,
  getRandomColor,
  shortDescriptionPgCompatible,
} = require('../../../../server/scripts/utils.js')();
import {
  authManager,
  basicManager,
  publisherManager,
  soundcastManager,
  soundcastExtManager,
  userManager,
} from '../../../helpers/managers';
import {
  createEditorState,
  editorStateToRaw,
  editorStateToRawAndHtml,
  rawIsEmpty,
} from '../../../helpers/editorStateHelper.js';

import Status from './soundcast/status';
import Title from './shared/Title';
import Description from './soundcast/description';
import MultiSelectDraggable from './soundcast/multiselectdraggable';
import Category from './soundcast/category';
import CoverArt from './soundcast/coverart';
import Features from './soundcast/features';
import Pricing from './soundcast/pricing';
import Subscription from './soundcast/subscription';
import BundleOtherSettings from './soundcast/bundle_othersettings';
import { DivisionHeadline } from './shared/styled-components';
import {
  canUserAccessFeature,
  canUserUse100PercenOffCoupon,
} from '../../../helpers/userinfoHelper';
import { ALERTS } from '../../../helpers/texts';
import { hasDiscountsBelowMinimumPrice, hasValidCouponCodes } from '../../../helpers/payments';
import { signupConfirmBodyTemplate } from '../../../../server/scripts/helpers/emailTemplate';
import { getOrderFromProps } from './managed/sorting_utils';
const {
  trimSpaces,
} = require('../../../../server/scripts/utils')();

const categories = Object.keys(podcastCategories).map(i => podcastCategories[i].name);

export default class CreateBundle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      soundcastId: '',
      soundcasts: [{}],
      selectedSoundcasts: [],
      selectedSoundcastsArr: [],
      title: '',
      short_description: '',
      long_description: null,
      category: '',
      imageURL: '',
      previewImage: null,
      landingPage: true,
      featuresTitle: '',
      features: [''],
      forSale: false,
      prices: [],
      confirmationEmail: null,
      enableSignupEmail: true,
      subscribers: {},
      enableFaqOnLandingPage: true,
      enableRatings: true,
      disableSignup: false,
      proUser: false,
      userPlan: '',
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Upgrade',
        onClose: () => {},
        upgrade: false,
      },
      imagecrop: {
        show: false,
        onCrop: () => {},
        onClose: () => {},
        file: null,
      },
      saving: false,
      notFound: false,
      order: {},
    };

    this.publisherId = '';
    this.saveSoundcast = this.saveSoundcast.bind(this);
    this.onSelectSoundcast = this.onSelectSoundcast.bind(this);
    this.modalHandler = this.modalHandler.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleChargeOption = this.handleChargeOption.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onResetToDefaultConfirmationEmail = this.onResetToDefaultConfirmationEmail.bind(this);
    this.onSoundcastInputChange = this.onSoundcastInputChange.bind(this);
    this.onSoundcastStateChange = this.onSoundcastStateChange.bind(this);
    this.openImageCropModal = this.openImageCropModal.bind(this);
    this.closeImageCropModal = this.closeImageCropModal.bind(this);
    this.initFilepondImageCropperFor = this.initFilepondImageCropperFor.bind(this);
  }

  componentDidMount() {
    this.handleDefaultSoundcast();
    this.checkUserProStatus(this.props.userInfo);

    const order = getOrderFromProps(this.props);
    this.setState({ order });
  }

  componentWillReceiveProps(nextProps) {
    const { userInfo } = nextProps;

    // will assign soundcast details if edit mode
    const { soundcastId } = this.state;
    if (isEmpty(soundcastId) && isEmpty(this.publisherId)) {
      this.handleDefaultSoundcast(nextProps);
    }

    if (!this.state.proUser && userInfo.publisher) {
      this.checkUserProStatus(userInfo);
    }

    const order = getOrderFromProps(nextProps);
    this.setState({ order });
  }

  async handleDefaultSoundcast(props = {}) {
    props = !isEmpty(props) ? props : this.props;
    const { editmode, userInfo, match = {} } = props;

    // if empty publisher do it later
    // this is mandatory for querying soundcasts
    if (isEmpty(userInfo.publisherID)) {
      console.log('publisher still empty');
      return false;
    }

    // we have to set `publisherId` immediately once we have it
    // to avoid requerying the publishers soundcasts
    this.publisherId = userInfo.publisherID;
    const soundcasts = await this.fetchPublisherSoundcasts(this.publisherId);
    console.log(soundcasts);

    const initNewSoundcastsBundle = () => {
      const soundcastId = `${moment().format('x')}s`;
      console.log('Create mode new', soundcastId);
      const { editorState: long_description } = createEditorState();
      const {
        editorState: confirmationEmail,
        html: confirmationEmailHtml,
        isDefault: confirmationEmailIsDefault,
      } = createEditorState('', signupConfirmBodyTemplate());
      return this.setState({
        soundcastId,
        long_description,
        confirmationEmail,
        confirmationEmailHtml,
        confirmationEmailIsDefault,
        soundcasts,
        selectedSoundcasts: [...soundcasts],
      });
    };

    // if not edit mode just assign the soundcastId
    // and start the create page normally
    if (!editmode) {
      return initNewSoundcastsBundle();
    }

    const { id: soundcastId } = match.params;
    if (isEmpty(soundcastId)) {
      return this.setState({ notFound: true });
    }
    const soundcast = await soundcastManager.getById(soundcastId);
    if (isEmpty(soundcast)) {
      return this.setState({ notFound: true });
    }
    if (!soundcast.bundle) {
      console.log('Edit mode broken (found not bundle)', soundcastId, soundcast);
      // if soundcast is empty or if its not a real bundle
      // ? just render the page normally
      return initNewSoundcastsBundle();
    }
    soundcast.subscribed = await soundcastManager.getSubscribedObj(soundcastId, soundcast.subscribed || {});

    console.log('Edit mode', soundcastId, soundcast);
    const {
      title,
      enableFaqOnLandingPage = true,
      enableRatings = true,
      disableSignup = false,
      imageURL,
      previewImage,
      short_description,
      long_description: longDescriptionJson,
      landingPage,
      featuresTitle,
      features,
      forSale,
      prices,
      confirmationEmail: confirmationEmailDeprecated, // TODO remove
      enableSignupEmail = true,
      category,
      subscribed,
      soundcastsIncluded,
    } = soundcast;

    const { editorState: long_description } = createEditorState(longDescriptionJson);

    const confirmationEmailExt = await soundcastExtManager.getProp(soundcastId, 'confirmationEmail');
    const confirmationEmailJson = isEmpty(confirmationEmailExt)
      ? confirmationEmailDeprecated
      : confirmationEmailExt;
    const {
      editorState: confirmationEmail,
      html: confirmationEmailHtml,
      isDefault: confirmationEmailIsDefault,
    } = createEditorState(confirmationEmailJson, signupConfirmBodyTemplate());

    // set included soundcast
    const selectedSoundcasts = [...soundcasts].filter(psoundcast => {
      return soundcastsIncluded.includes(psoundcast.id);
    });

    return this.setState({
      soundcastId,
      soundcasts,
      title,
      short_description,
      landingPage,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
      imageURL: imageURL ? imageURL : '',
      previewImage: previewImage || '',
      long_description,  // EditorState
      confirmationEmail, // EditorState
      confirmationEmailHtml,
      confirmationEmailIsDefault,
      enableSignupEmail,
      featuresTitle: featuresTitle || '',
      features,
      forSale,
      prices,
      selectedSoundcasts,
      category,
      subscribers: subscribed || {},
    });
  }

  checkUserProStatus(userInfo) {
    let proUser = false;
    let userPlan = '';
    if ('publisher' in userInfo && isObject(userInfo.publisher)) {
      if ('plan' in userInfo.publisher) {
        const inSeconds = Number(moment().format('X'));
        proUser = userInfo.publisher.current_period_end > inSeconds;
        if (proUser) {
          userPlan = userInfo.publisher.plan;
        }
      } else if ('beta' in userInfo.publisher) {
        proUser = true;
      }
    }

    this.setState({
      proUser,
      userPlan,
    });
  }

  areRequiredFieldsValid() {
    const { title, short_description, selectedSoundcasts, category } = this.state;
    return [title, short_description, selectedSoundcasts, category].every(value => !isEmpty(value));
  }

  fetchPublisherSoundcasts(publisherID) {
    return new Promise(async resolve => {
      const publisherSoundcasts = await publisherManager.getProp(publisherID, 'soundcasts');

      const soundcastIds = Object.keys(publisherSoundcasts);
      const allSoundcasts = [];
      for (let x = 0; x < soundcastIds.length; x++) {
        const soundcast = await soundcastManager.getById(soundcastIds[x]);

        if (isEmpty(soundcast)) {
          console.error(
            `Error: Bundle fetchPublisherSoundcasts empty soundcast ${soundcastIds[x]}`
          );
          continue;
        }
        const { title, published, bundle = false } = soundcast;

        // do not include not published and bunled soundcast
        if (!bundle) {
          allSoundcasts.push({
            id: soundcastIds[x],
            published,
            title,
          });
        }
      }

      resolve(allSoundcasts);
    });
  }

  onSelectSoundcast(selectedSoundcasts) {
    this.setState({ selectedSoundcasts });
  }

  saveSoundcast(published) {
    return () => {
      // before we proceed verify the required props first
      const canProceed = this.areRequiredFieldsValid();
      if (!canProceed) {
        return this.showModal({
          content: 'Please fill in all the required fields to continue.',
        });
      }

      this.setState({ saving: true }, async () => {
        try {
          await this.saveInternal(published);
        } catch (err) {
          return this.showModal({
            title: 'ERROR',
            content: `Something went wrong: ${(err && err.message) || 'Unknown error'}`,
            onClose: () => this.setState({ saving: false }),
          });
        }
      });
    };
  }

  async saveInternal(published) {
    let {
      soundcastId,
      title,
      subscribers,
      short_description,
      long_description,
      imageURL,
      previewImage,
      landingPage,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
      featuresTitle,
      features,
      selectedSoundcasts,
      forSale,
      prices,
      confirmationEmail,
      confirmationEmailHtml,
      confirmationEmailIsDefault,
      enableSignupEmail,
      category,
      order,
    } = this.state;
    const { editmode = false, userInfo, history } = this.props;

    // set imageURL if empty
    imageURL = isEmpty(imageURL)
      ? `https://dummyimage.com/300.png/${getRandomColor()}/ffffff&text=${encodeURIComponent(
          title
        )}`
      : imageURL;

    if (isEmpty(title)) {
      return this.showModal({
        title: 'Soundcast bundle Title is missing',
        content: 'Please enter a soundcast title before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    if (isEmpty(short_description)) {
      return this.showModal({
        title: 'Soundcast bundle Description is missing',
        content: 'Please enter a short description for the soundcast before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    if (selectedSoundcasts.length < 2) {
      return this.showModal({
        content: 'Please select at least two soundcasts to form the bundle.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    if (isEmpty(category)) {
      return this.showModal({
        title: 'Soundcast bundle Category is missing',
        content: 'Please choose a category before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // if pricing isn't specified, then this is a free soundcast
    const hasPrice = !isEmpty(prices);
    if (!hasPrice) {
      prices = [{ billingCycle: 'free', price: 'free' }];
    }

    if (!canUserUse100PercenOffCoupon(prices)) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_COUPONS_100POFF.NO_ACCESS,
        upgrade: true,
        onClose: () => this.setState({ saving: false }),
      });
    }

    // prices of discounts should be not lower than minimum
    if (hasDiscountsBelowMinimumPrice(prices)) {
      return this.showModal({
        title: 'Coupon discount',
        content: 'One of your coupon codes discounted price is below the minimum charge amount.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // prices has coupon but invalid
    if (!hasValidCouponCodes(prices)) {
      return this.showModal({
        title: 'Coupon Code',
        content: 'You have entered an invalid coupon code.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // store the sort order of soundcasts in bundle soundcastId
    this.props.updateManagedBundleSouncastsOrderCreator({
      soundcastId,
      order,
    });

    // ensure some limitations are applied
    landingPage = canUserAccessFeature('SOUNDCAST_PRIVATE') ? landingPage : true;
    if (prices.length > 0 && !canUserAccessFeature('SOUNDCAST_MULTIPLE_PRICING')) {
      prices = [prices[0]];
    }

    // for platinum users with white label, generate productSku
    // under format priceIndex_billingCycle_soundcastId
    if (canUserAccessFeature('MOBILE_WHITE_LABEL')) {
      prices = prices.map((price, index) => {
        if (!('billingCycle' in price)) return price;
        return {
          ...price,
          productSku: `${index}_${trimSpaces(price.billingCycle)}_${soundcastId}`,
        };
      });
    }

    const user = authManager.getCurrentUser();
    if (user) {
      const longDescriptionRaw = editorStateToRaw(long_description);
      const {
        raw: confirmationEmailRaw = null,
        html: confirmationEmailHtmlNew = null,
      } = editorStateToRawAndHtml(confirmationEmail);
      const confirmationEmailRawJson =
        isEqual(confirmationEmailHtml, confirmationEmailHtmlNew) && confirmationEmailIsDefault 
        ? null
        : JSON.stringify(confirmationEmailRaw);

      const creatorID = user.uid;
      const last_update = Number(moment().format('X'));
      const soundcast = {
        title,
        short_description: shortDescriptionPgCompatible(short_description),
        long_description: rawIsEmpty(longDescriptionRaw) ? null : JSON.stringify(longDescriptionRaw),
        imageURL,
        previewImage,
        landingPage,
        enableFaqOnLandingPage,
        enableRatings,
        disableSignup,
        featuresTitle,
        features: features || null,
        category,
        forSale,
        prices,
        enableSignupEmail,

        // mandatory props
        bundle: true,
        soundcastsIncluded: selectedSoundcasts.map(item => item.id),
        published,
        creatorID,
        publisherID: userInfo.publisherID,
        date_created: editmode ? null : moment().format('X'),
        last_update,
      };

      const oldsoundcast = editmode ? (await soundcastManager.getById(soundcastId)) || {} : {};

      // holds soundcast bundle info, wether from editmode or not
      const newSoundcast = Object.assign({}, oldsoundcast, soundcast);
      delete newSoundcast.confirmationEmail;

      // adding soundcast bundle to firebase should be done first
      await Promise.all([
        soundcastManager.save(soundcastId, newSoundcast),
        soundcastExtManager.saveProp(soundcastId, 'confirmationEmail', confirmationEmailRawJson),
      ]);

      // #219 Issue - update subscribers soundcast lists
      const soundcastsRemoved = [];
      const soundcastsAdded = [];
      const subscriberIds = Object.keys(subscribers || {});
      const bundleOldSoundcastsIncluded = oldsoundcast.soundcastsIncluded || [];
      for (const i of bundleOldSoundcastsIncluded) {
        if (!newSoundcast.soundcastsIncluded.some(j => j === i)) {
          soundcastsRemoved.push(i);
        }
      }

      for (const i of newSoundcast.soundcastsIncluded) {
        if (!(oldsoundcast.soundcastsIncluded || []).some(j => j === i)) {
          soundcastsAdded.push(i);
        }
      }

      const requests = subscriberIds.map(async subscriberId => {
        return new Promise(async (resolve, reject) => {
          try {
            // update subscribers data about the soundcast to be removed
            await Promise.all(
              soundcastsRemoved.map(isoundcastId => {
                return basicManager.update({
                  [`soundcasts/${isoundcastId}/subscribed/${subscriberId}`]: null, // deprecated
                  [`soundcastExts/${isoundcastId}/subscribed/${subscriberId}`]: null,
                  [`users/${subscriberId}/soundcasts/${isoundcastId}`]: null,
                });
              })
            );

            // update subscribers data about the soundcast to be added
            // all based from the parent soundcast
            if (!isEmpty(soundcastsAdded)) {
              const subscription = await userManager.getProp(
                subscriberId,
                `soundcasts/${soundcastId}`
              );

              // updating subscription, see github #219 issue
              await Promise.all(
                soundcastsAdded.map(isoundcastId => {
                  return basicManager.update({
                    [`soundcastExts/${isoundcastId}/subscribed/${subscriberId}`]: true,
                    [`users/${subscriberId}/soundcasts/${isoundcastId}`]: {
                      ...subscription,
                      bundle: null,
                      bundleId: soundcastId,
                    },
                  });
                })
              );
            }

            resolve();
          } catch (err) {
            reject(err);
          }
        });
      });

      // process all data to subscribers
      await Promise.all(requests);

      if (subscriberIds.length && soundcastsAdded.length) {
        await new Promise(resolve => {
          Axios.post('/api/set_feed_subscribers', { soundcastIds: soundcastsAdded })
            .then(res => {
              if (!(res && res.data === 'Success')) {
                alert(`Error: create_edit_bundle set_feed_subscribers ${res && res.data}`);
              }
              resolve();
            })
            .catch(err => {
              const errMsg = `Error: create_edit_bundle set_feed_subscribers`;
              alert(`${errMsg} ${err && err.response && err.response.data}`);
              console.error(`${errMsg} ${err && err.response && err.response.data}`);
              resolve();
            });
        });
      }

      Promise.all([
        new Promise((resolve, reject) => {
          // add soundcast to publisher, owner and administrators
          const { administrators = {} } = userInfo.publisher;
          const administratorIds = Object.entries(administrators)
            .filter(([, value]) => value !== false && value !== null)
            .map(([key]) => key);

          const nodeUpdates = administratorIds.reduce((admins, adminId) =>
            {
              if ( adminId !== creatorID) {
                admins[`users/${adminId}/soundcasts_managed/${soundcastId}`] = true;
              }
              return admins;
            }, 
            {
              [`publishers/${userInfo.publisherID}/soundcasts/${soundcastId}`]: true,
              [`users/${creatorID}/soundcasts_managed/${soundcastId}`]: true,
            }
          );

          basicManager
            .update(nodeUpdates)
            .then(resolve)
            .catch(err => {
              console.log(`ERROR occured when adding soundcast to publisher, owner or administrators: ${JSON.stringify(err)}`);
              reject(err);
            });
        }),

        new Promise(async (resolve, reject) => {
          try {
            await Axios.post('/api/soundcast', {
              title,
              soundcastId,
              shortDescription: shortDescriptionPgCompatible(short_description),
              publisherId: userInfo.publisherID,
              imageUrl: imageURL,
              previewImage,
              category,
              published,
              landingPage,
              forSale,
              updateDate: last_update,
              bundle: true,
            });

            let stripePlansError = null;
            // if there are prices, update plans
            if (prices.length && userInfo.publisher && userInfo.publisher.stripe_user_id) {
              const couponsToRemove = [];

              // only remove coupon for plan based plans and non trial coupons
              (newSoundcast.prices || [])
                .filter(({ billingCycle = '' }) => billingCycle !== 'one time')
                .forEach(price => {
                  (price.coupons || [])
                    .filter(({ couponType = '' }) => couponType !== 'trial_period')
                    .forEach(coupon => couponsToRemove.push(coupon.code));
                });

              const postBody = {
                soundcastID: soundcastId,
                publisherID: userInfo.publisherID,
                stripe_account: userInfo.publisher.stripe_user_id,
                title,
                prices: landingPage && forSale ? prices : [],
                couponsToRemove,
              };
              try {
                await Axios.post('/api/createUpdatePlans', postBody);
              } catch (err) {
                const errorMessage = getPath(err, 'response.data',
                  'Something went wrong when requesting data to server. ' +
                  (err && err.message || 'Unknown error'),
                );
                console.warn(`WARNING: createUpdatePlans errored `, errorMessage, JSON.stringify(postBody) );
                stripePlansError = 'There was a problem updating the bundle pricing, please contact support. ' +
                  errorMessage;
              }
            }
            resolve(stripePlansError);
          } catch (err) {
            console.log('ERROR API post soundcast: ', err);
            reject(err);
            // resolve('API post soundcast errored: ' + ((err && err.message) || 'Unknown error'));
          }
        }),
      ])
        .then((warnings) => {
          const { editmode = false } = this.props;
          // if success show a message
          this.setState({ saving: false }, () => {
            let content = editmode
              ? 'Your soundcast bundle has been successfully updated.'
              : 'Your new soundcast bundle has been successfully created.';
            warnings.forEach(warning => {
              if (!isEmpty(warning)) {
                content += ' ' + warning;
              }
            });

            this.showModal({
              content,
              onClose: () => {
                history.push('/dashboard/soundcasts/bundles');
              },
            });
          });
        })
        .catch(errors => {
          console.log('failed to complete adding soundcast', errors);
          this.setState({ saving: false }, () => {
            const { editmode = false } = this.props;
            this.showModal({
              title: `Error ${editmode ? 'Editing' : 'Creating'} Soundcast Bundle`,
              content:
                `There was a problem ${editmode ? 'editing' : 'creating'} your soundcast bundle, please contact support.`,
            });
          });
        });
    }
  }

  onResetToDefaultConfirmationEmail() {
    const {
      editorState: confirmationEmail,
      html: confirmationEmailHtml,
      isDefault: confirmationEmailIsDefault,
    } = createEditorState('', signupConfirmBodyTemplate());
    this.setState({
      confirmationEmail,
      confirmationEmailHtml,
      confirmationEmailIsDefault,
    });
  }

  onSoundcastInputChange(key = 'title') {
    return e => {
      const input = e.target.value;
      this.setState({
        [key]: input || '',
      });
    };
  }

  onSoundcastStateChange(key = 'title', value = '', cb = () => {}) {
    return () => {
      const oldstatevalue = this.state[key];
      this.setState({ [key]: value }, () => {
        cb(oldstatevalue);
      });
    };
  }

  handleChargeOption() {
    const { forSale } = this.state;
    const { userInfo } = this.props;

    if (!forSale) {
      if (!userInfo.publisher.stripe_user_id) {
        this.saveSoundcast(false);
        this.setState({
          paypalModalOpen: true,
        });
      } else {
        this.setState({
          forSale: !forSale,
          prices: [
            {
              paymentPlan: 'soundcast purchase',
              billingCycle: 'one time',
              price: 1,
              currency: 'USD',
            },
          ],
        });
      }
    } else {
      this.setState({
        forSale: !forSale,
        prices: [{ price: 'free' }],
      });
    }
  }

  handlePaypalModalClose() {
    if (this.state.paypalModalOpen) {
      this.setState({ paypalModalOpen: false });
    }
  }

  handlePaypalInput() {
    const { paypalEmail, forSale } = this.state;
    const { userInfo } = this.props;
    publisherManager.saveProp(userInfo.publisherID, 'paypalEmail', paypalEmail);
    this.setState({
      paypalModalOpen: false,
      forSale: !forSale,
      prices: [{ paymentPlan: '', billingCycle: 'monthly', price: '' }],
    });
  }

  onEditorStateChange(statekey) {
    return editorState => {
      this.setState({ [statekey]: editorState });
    };
  }

  onConfirmationStateChange(editorState) {
    this.setState({ confirmationEmail: editorState });
  }

  handlePriceInputs(i, e) {
    let prices = [...this.state.prices];
    if (e.target.name === 'billingCycle' && prices[i].coupons) {
      prices[i].coupons.forEach(i => (i.couponType = 'discount'));
    }
    prices[i][e.target.name] = e.target.value;
    this.setState({ prices });
  }

  addPriceOption() {
    let prices = [...this.state.prices];
    const price = {
      paymentPlan: 'soundcast purchase',
      billingCycle: 'one time',
      price: 1,
      currency: 'USD',
    };
    prices.push(price);
    this.setState({ prices });
  }

  deletePriceOption(i) {
    let prices = [...this.state.prices];
    if (prices.length > 1) {
      prices.splice(i, 1);
    } else {
      prices[0] = {
        paymentPlan: 'soundcast purchase',
        billingCycle: 'monthly',
        price: 1,
        currency: 'USD',
      };
    }
    this.setState({ prices });
  }

  renderImageCropModal() {
    const { show, onCrop, onClose, file } = this.state.imagecrop;
    return <ImageCropModal open={show} handleClose={onClose} onCrop={onCrop} file={file} />;
  }

  openImageCropModal(metadata) {
    this.setState({
      imagecrop: {
        show: true,
        onClose: this.closeImageCropModal,
        ...metadata,
      },
    });
  }

  closeImageCropModal() {
    this.openImageCropModal({
      show: false,
    });
  }

  initFilepondImageCropperFor(options) {
    this.openImageCropModal(
      options({
        close: this.closeImageCropModal,
      })
    );
  }

  modalHandler(metadata = {}) {
    let { show = false, title = '', content = '', upgrade = false, onClose = false } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            onClose: !show ? false : onClose,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showModal(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, upgrade, onClose } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.modalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton id="actionButtonTest1" onClick={actionBtnClick}>
          {actionLabel}
        </ActionButton>
        {upgrade && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={() => {
              this.modalHandler({ show: false })();
              if (onClose) {
                onClose();
              }
            }}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderPricingOptions() {
    const { landingPage, forSale, prices, userPlan, soundcastId } = this.state;

    return (
      <Pricing
        public={landingPage}
        forsale={forSale}
        prices={prices}
        userPlan={userPlan}
        soundcastId={soundcastId}
        onEnableCharge={this.handleChargeOption}
        onPricesUpdate={prices => this.onSoundcastStateChange('prices', prices)()}
        showModal={this.showModal}
      />
    );
  }

  renderSaveButtons() {
    const { saving } = this.state;

    let content = (
      <div className="col-lg-12" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 17, width: '100%', marginTop: 50 }}>
          <span>Saving</span>
        </div>
        <div className="" style={{ marginTop: 10, width: '100%' }}>
          <Dots color="#727981" size={32} speed={1} />
        </div>
      </div>
    );

    if (!saving) {
      content = (
        <React.Fragment>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="saveDraftSoundcastBtnTest"
              className="btn"
              style={styles.draftButton}
              onClick={this.saveSoundcast(false)}>
              <span>Save Draft</span>
            </div>
          </div>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              className="btn btn-default"
              style={{ ...styles.draftButton, ...styles.publishButton }}
              onClick={this.saveSoundcast(true)}>
              <span>Publish</span>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return <div style={styles.actionButtonWrapper}>{content}</div>;
  }

  renderBundleOtherSettings() {
    const {
      soundcastId,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
    } = this.state;

    return (
      <BundleOtherSettings
        soundcastId={soundcastId}
        enableFaqOnLandingPage={enableFaqOnLandingPage}
        enableRatings={enableRatings}
        disableSignup={disableSignup}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
      />
    );
  }

  render() {
    const {
      soundcastId,
      title,
      short_description,
      long_description,
      category,
      imageURL,
      landingPage,
      featuresTitle,
      features,
      confirmationEmail,
      enableSignupEmail,
      soundcasts,
      selectedSoundcasts,
      order,
      notFound = false,
    } = this.state;
    const { match = {}, editmode = false } = this.props;
    const { id: paramsId = '' } = match.params || {};

    if (notFound) {
      return (
        <div style={{ padding: 20 }}>
          <div className="row" style={styles.rowDivision}>
            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
               <div style={styles.errorTxt} className="title-medium">
                 {`The given bundle ${paramsId} does not exist`}
               </div>
            </div>
          </div>
        </div>
      );
    }

    if (isEmpty(soundcastId) || isEmpty(this.publisherId)) {
      return (
        <div style={{ padding: 20 }}>
          <div className="row" style={styles.rowDivision}>
            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              <Loading text="Loading bundle..." />
            </div>
          </div>
        </div>
      );
    }

    return (
      <MuiThemeProvider>
        <div>
          <DivisionHeadline>
            <div className="row">
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <div className="headline">
                  <div className="title-medium">Create a Multi-Soundcast Bundle</div>
                </div>
              </div>
            </div>
          </DivisionHeadline>
          <div style={{ minHeight: window.innerHeight - 83 - 70 }}>
            <div style={{ padding: 20 }}>
              <Status
                soundcastId={soundcastId}
                public={landingPage}
                onStatusChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
                viewLinks={true}
                showSignupLink={false}
                publicText="This is a public soundcast bundle"
                privateText="This is a private soundcast bundle"
              />
              <Title
                label="Bundle Title"
                value={title}
                required={true}
                onChange={this.onSoundcastInputChange('title')}
              />
              <Description
                label="Short Description"
                required={true}
                value={short_description}
                placeholder="A short description of this bundle (300 characters max)"
                helper="300 characters max"
                onChange={this.onSoundcastInputChange('short_description')}
                maxlength={300}
              />
              <MultiSelectDraggable
                soundcastId={soundcastId}
                label="Soundcasts included in the bundle"
                required={true}
                items={soundcasts}
                selectedItems={selectedSoundcasts}
                onSelected={this.onSelectSoundcast}
                onDragEnd={this.props.updateManagedBundleSouncastsOrderCreator}
                onFetchOrder={this.props.fetchManagedBundleSoundcastsOrderCreator}
                order={order}
                editmode={editmode}
              />
              <Category
                required={true}
                list={categories}
                value={category}
                onChange={category => this.onSoundcastStateChange('category', category)()}
              />
              <CoverArt
                publisherId={this.publisherId}
                soundcastId={soundcastId}
                label="Bundle Cover Art"
                helper="(Square image between 800 x 800 pixels and 3000 x 3000 pixels, in .jpeg or .png format)"
                value={imageURL}
                datakey="imageURL"
                datakeyPreview="previewImage"
                withPreview={true}
                withCrop={true}
                cropperHandler={this.initFilepondImageCropperFor}
                autoDeletePrevious={false}
                autoSave={false}
                onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
                uploader={{
                  options: {
                    imageValidateSizeMinWidth: 800,
                    imageValidateSizeMinHeight: 800,
                  },
                }}
              />
              <Features
                label="Features Section"
                helper="(list the main benefits and features of this soundcast)"
                placeholder="e.g. Learn how to analyze financial statement with ease"
                list={features}
                onChange={features => this.onSoundcastStateChange('features', features)()}
                onTitleChange={value => {
                  this.setState({
                    featuresTitle: value || '',
                  });
                }}
                title={featuresTitle}
                enableEnterAdd={true}
              />
              <Description
                label="Long Description"
                value={long_description}
                onChange={this.onEditorStateChange('long_description')}
                richEditor={true}
              />
              {this.renderPricingOptions()}
              {this.renderBundleOtherSettings()}
              <Subscription
                signupEmailValue={confirmationEmail}
                onChangeSignupEmail={this.onEditorStateChange('confirmationEmail')}
                onResetToDefaultEmail={this.onResetToDefaultConfirmationEmail}
                enableSignupEmail={enableSignupEmail}
                onChangeSignupEmailToggle={value =>
                  this.onSoundcastStateChange('enableSignupEmail', value)()
                }
              />
              {this.renderSaveButtons()}
            </div>
          </div>
          {this.renderAlertModal()}
          {this.renderImageCropModal()}
        </div>
      </MuiThemeProvider>
    );
  }
}

CreateBundle.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
};
